/**
 * 右侧收藏组件
 * @author chenqunfneg
 * @since 18/06/07
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import store from 'store';
import Stat from '@fe/common/lib/stat';
import { sendStat } from 'utils/common';
import { getTabPath, pushState } from 'utils/store-tabs';
import VARIABLE from 'constants/variable.json5';

import './nav-collection.less';

export default class NavCollection extends Component {
  static propTypes = {
    setActiveTab: PropTypes.func,
  };

  // 获取分类下标值
  getCategoryIndex = category => {
    const { storeTabs } = store.getState();
    const tabs = storeTabs.tabs;
    const index = tabs && tabs.find(el => el.name === category).index;
    return index;
  };

  render() {
    return (
      <div
        className="cmp nav-collection"
        title="收藏夹"
        onClick={() => {
          const p = /^\/template(\/)?(recommend|store|multipage|longpage|shortvideo|vip|enterprise|mytpl)?(\.html)?$/;
          // 若不是在模版市场的其他页面打开,则新开一个页面
          if (!p.test(location.pathname)) {
            window.open(`/template/mytpl.html`);
            return;
          }
          if (this.props.setActiveTab) {
            const index = this.getCategoryIndex(VARIABLE.MY_TPL);
            const path = getTabPath(index);
            this.props.setActiveTab(index, path);
            pushState(path);
          }
          sendStat(
            'RP_STORE',
            '模版市场',
            '右侧悬浮收藏按钮',
            Stat.ACTION_CLICK,
            {
              id: 'web_mobanmarket_moban_rightfavorite_click',
            }
          );
        }}>
        <i className="s-icon icon-collect2" />
        <div>收藏</div>
      </div>
    );
  }
}
